export const Card = ({ children, className, onClick }) => (
    <div className={` ${className}`}onClick={onClick}>{children}</div>
  );
  
  export const CardContent = ({ children }) => (
    <div className=" ">{children}</div>
  );
  
  